// extracted by mini-css-extract-plugin
export const navigation = "navigation-module--navigation--tCgAu";
export const small = "navigation-module--small--2VhT7";
export const menu = "navigation-module--menu--23iyb";